import _ from 'lodash';

//Constantes de fieldProperties
const textFieldProperties = {type: 'string', title: ''}
const numberFieldProperties = {type: 'number', title: ''}
const dataFieldProperties = {type: 'string', title: '', format: 'date'}
const arquivoFieldProperties = {type: 'string', title: '', format: 'data-url'}
const emailFieldProperties = {type: 'string', title: '', format: 'email'}

//Constantes de uiSchema
const textocurtoUiSchema = {}
const textolongoUiSchema = {'ui:widget': 'textarea'}
const numeroUiSchema = {'ui:widget': 'updown'}
const dataUiSchema = {'ui:widget': 'date'}
const selectUiSchema = {'ui:widget': 'select'}
const radioUiSchema = {'ui:widget': 'radio', 'ui:options': {'inline': false}}
const checkboxUiSchema = {'ui:widget': 'checkboxes'}
const arquivoUiSchema = {}
const emailUiSchema = {}

export function build(itens, titulo, descricao){
    //Estado inicial para o formSchema
    let formSchema = {
        schema:{
            title: '',
            description: '',
            type: 'object',
            required: [],
            properties: {}
        },
        uiSchema :{}
    }
    if(titulo === ''){
        titulo = 'Sem título';
    }
    if(descricao === ''){
        descricao = 'Sem descrição';
    }

    formSchema.schema.required.length = 0;
    formSchema.schema.title = titulo;
    formSchema.schema.description = descricao;

    itens.forEach(item => {
        addField(item, formSchema)
    });
    return formSchema;
}

export function opcoesSemVagas(itens){

    let opcao = []
    opcao.length = 0

    itens.forEach(item => {
        const TIPO = item.tipo;
        if(item.opcoes && item.opcoes[0].limiteDeVagas != undefined && (TIPO === 'select' || TIPO === 'radio' || TIPO === 'checkbox')){
            const PERGUNTA = item.pergunta !== '' ? item.pergunta : 'Sem Título';
            opcao[`questao_${item.id}`] = getFieldPropertiesOpcoesSemVagaInfo(TIPO, PERGUNTA, item.opcoes);
            opcao.length = opcao.length + 1
        }
    });

    return opcao;
    
}

function addField(item, formSchema){
    //valores do item
    const id = item.id;
    let pergunta;
    if(item.pergunta !== ''){
        pergunta = item.pergunta;
    }else{
        pergunta = 'Sem Título'
    }
    const obrigatorio = item.obrigatorio;
    const tipo = item.tipo;
    const valor = item.valor;

    //Montando a estrutura do formSchema a partir dos dados
    let fieldProperties;
    if(tipo === 'select' || tipo === 'radio' || tipo === 'checkbox'){
        fieldProperties = getFieldPropertiesOpcoes(tipo, pergunta, item.opcoes);
    }else{
        fieldProperties = getFieldProperties(tipo, pergunta);
        fieldProperties.default = undefined;
        if(valor !== undefined){
            fieldProperties.default = valor;
        }
    }
    const uiSchema = getUiSchema(tipo);
    if(valor !== undefined){
            uiSchema['ui:readonly'] = true;
        }

    //Nome para identificar as questoes no formSchema
    const name = `questao_${id}`

    //Adicionando os atributos no formSchema
    addRequiredField(obrigatorio, name, formSchema);
    formSchema.schema.properties[name] = { ...fieldProperties}
    if(!_.isEmpty(uiSchema)){
        formSchema.uiSchema[name] = uiSchema;
    }
    formSchema.uiSchema['ui:order'] = (formSchema.uiSchema['ui:order'] || []).concat(name);
}

function getFieldProperties(tipo, pergunta){
    let properties;
    switch (tipo) {
		case 'textocurto': 
            properties = textFieldProperties;
            break;   
        case 'email': 
            properties = emailFieldProperties;
            break;   
		case 'textocurto-cpf': 
            properties = textFieldProperties;
            break;   
		case 'textocurto-cnpj': 
            properties = textFieldProperties;
            break;   
		case 'textocurto-telefone': 
            properties = textFieldProperties;
            break;   
		case 'textocurto-cep': 
            properties = textFieldProperties;
            break;   
		case 'textocurto-dinheiro': 
            properties = textFieldProperties;
            break;   
		case 'textolongo':
            properties = textFieldProperties;
            break;
		case 'numero':
            properties = numberFieldProperties;
            break;
		case 'data':
            properties = dataFieldProperties;
            break;
        case 'arquivo':
            properties = arquivoFieldProperties;
            break;
        default:
            break;
    }
    properties.title = pergunta;    
    if(tipo === 'arquivo')
        properties.title = properties.title+' (No máx. 9.53Mb)';
    return properties;
}

function getFieldPropertiesOpcoes(tipo, pergunta, opcoes){
    let properties;
    switch (tipo) {
        case 'select':
		    properties = {type: 'string', title: '', enum: [] };//selectFieldProperties;
            properties.enum.length = 0;
            opcoes.forEach(opcao => {
                properties.enum.push(opcao.texto+getValor(opcao.valor)+getVagasRestantes(opcao.limiteDeVagas));
            });
		    break;
		case 'radio':
		    properties = {type: 'string', title: '', enum: [] };//radioFieldProperties;
            properties.enum.length = 0;
            opcoes.forEach(opcao => {
                properties.enum.push(opcao.texto+getValor(opcao.valor)+getVagasRestantes(opcao.limiteDeVagas));
            });
            break;
        case 'checkbox':
		    properties = {type: 'array', title: '', items: {type: 'string', enum: []}, 'uniqueItems': true};//checkboxFieldProperties;
            properties.items.enum.length = 0;
            opcoes.forEach(opcao => {
                properties.items.enum.push(opcao.texto+getValor(opcao.valor)+getVagasRestantes(opcao.limiteDeVagas));
            });
            break;
        default:
            break;
    }
    properties.title = pergunta;
    return properties;
}

function getFieldPropertiesOpcoesSemVagaInfo(tipo, pergunta, opcoes){
    let properties;
    switch (tipo) {
        case 'select':
		    properties = {type: 'string', title: '', opcoes: [] };//selectFieldProperties;
            properties.opcoes.length = 0;
            opcoes.forEach(opcao => {
//properties.opcoes.push({semVagas: opcao.texto+getValor(opcao.valor), comVagas: opcao.texto+getValor(opcao.valor)+getVagasRestantes(opcao.limiteDeVagas)});                
                properties.opcoes.push({semVagas: opcao.texto, comVagas: opcao.texto+getValor(opcao.valor)+getVagasRestantes(opcao.limiteDeVagas)});
            });
		    break;
		case 'radio':
		    properties = {type: 'string', title: '', opcoes: [] };//radioFieldProperties;
            properties.opcoes.length = 0;
            opcoes.forEach(opcao => {
//properties.opcoes.push({semVagas: opcao.texto+getValor(opcao.valor), comVagas: opcao.texto+getValor(opcao.valor)+getVagasRestantes(opcao.limiteDeVagas)});                
                properties.opcoes.push({semVagas: opcao.texto, comVagas: opcao.texto+getValor(opcao.valor)+getVagasRestantes(opcao.limiteDeVagas)});
            });
            break;
        case 'checkbox':
		    properties = {type: 'array', title: '', items: {type: 'string', opcoes: []}, 'uniqueItems': true};//checkboxFieldProperties;
            properties.items.opcoes.length = 0;
            opcoes.forEach(opcao => {
//properties.items.opcoes.push({semVagas: opcao.texto+getValor(opcao.valor), comVagas: opcao.texto+getValor(opcao.valor)+getVagasRestantes(opcao.limiteDeVagas)});                
                properties.items.opcoes.push({semVagas: opcao.texto, comVagas: opcao.texto+getValor(opcao.valor)+getVagasRestantes(opcao.limiteDeVagas)});
            });
            break;
        default:
            break;
    }
    properties.title = pergunta;
    return properties;
}

function getUiSchema(tipo){
    let uiSchema;
    switch (tipo) {
		case 'textocurto':
            uiSchema = textocurtoUiSchema;   
            break; 
        case 'email':
            uiSchema = emailUiSchema;   
            break; 
		case 'textocurto-cpf':
            uiSchema = {classNames: "cpf_mask"};   
            break; 
		case 'textocurto-cnpj':
            uiSchema = {classNames: "cnpj_mask"};   
            break;
		case 'textocurto-telefone':
            uiSchema = {classNames: "phone_mask"};   
            break; 
		case 'textocurto-cep':
            uiSchema = {classNames: "cep_mask"};   
            break; 
		case 'textocurto-dinheiro':
            uiSchema = {classNames: "money_mask"};   
            break; 
		case 'textolongo':
            uiSchema = textolongoUiSchema;
            break;
		case 'numero':
            uiSchema = numeroUiSchema;
            break;
		case 'data':
            uiSchema = dataUiSchema;
            break;
		case 'select':
		    uiSchema = selectUiSchema;
		    break;
		case 'radio':
		    uiSchema = radioUiSchema;
            break
        case 'checkbox':
		    uiSchema = checkboxUiSchema;
            break;
        case 'arquivo':
		    uiSchema = arquivoUiSchema;
            break;
        default:
            break;
	}
    return uiSchema;
}

function addRequiredField(obrigatorio, name, formSchema){
    if(obrigatorio){
        formSchema.schema.required.push(name);
    }
}

function getValor(valor){
    if(valor !== undefined){
        return ' - R$'+valor;
    }else{
        return '';
    }
}

function getVagasRestantes(vagas){
    if(vagas !== undefined){
        return ' - Vagas: '+vagas;
    }else{
        return '';
    }
}


// WEBPACK FOOTER //
// ./src/components/formbuilder/helps/Builder.js